// Broadcast Templates populated from templates.json
export const broadcastTemplates = [
  {
    id: '6768c57d13bdab8ef5e08cad',
    name: 'Login_Verification',
    tags: ["Others"],
    content: `Hi {{name}},\n\nTo verify your login attempt, please enter the following code in the login page:\n\n🔑 **Your Code**: [Verification Code]\n\nThis code will expire in **[Time Duration]**.\n\nIf this wasn’t you, please reset your password or contact our support team at (support_method)`,
    category: 'AUTHENTICATION',
    language: 'English',
    footer: null,
    buttons: [{"type": "copy_code", "parameter": {"text": null, "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: null,
  },

  {
    id: '6768c57d13bdab8ef5e08cae',
    name: 'Login_Verification',
    tags: ["Others"],
    content: `"Hi {{name}},\n\nTo complete your purchase, please enter the following OTP (One-Time Password) on our login page:\n\n🛍️ **Your OTP**: [OTP Code]\nPlease do not share this code with anyone for your safety.\nThis OTP is valid for **[Time Duration]**. If you didn’t request this, please contact our support team for assistance at (support_method)."`,
    category: 'AUTHENTICATION',
    language: 'English',
    footer: `This code expires in 10 minutes.`,
    buttons: [{"type": "copy_code", "parameter": {"text": null, "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: null,
  },

  {
    id: '6768c57d13bdab8ef5e08caf',
    name: 'OTP_for_Checkout',
    tags: ["Others"],
    content: `Hi {{name}},\n\nTo complete your purchase, please enter the following OTP (One-Time Password) on our checkout page:\n\n🛍️ **Your OTP**: [OTP Code]\n\nThis OTP is valid for **[Time Duration]**. If you didn’t request this, please contact our support team for assistance at (support_method).`,
    category: 'AUTHENTICATION',
    language: 'English',
    footer: null,
    buttons: [{"type": "copy_code", "parameter": {"text": null, "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: null,
  },

  {
    id: '6768c57d13bdab8ef5e08caa',
    name: 'Two-Factor_Authentication (2FA) Code',
    tags: ["Others"],
    content: `Hi {{name}},\n\nFor added security, please use the following code to complete your login:\n\n🔑 **Your Code**: [Authentication Code]\n\nPlease do not share this code with anyone for your safety.\n\nIf you did not request this, please contact our support team immediately at (support_method).`,
    category: 'AUTHENTICATION',
    language: 'English',
    footer: `This code expires in 10 minutes.`,
    buttons: [{"type": "copy_code", "parameter": {"text": null, "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: null,
  },

  {
    id: '6768c57d13bdab8ef5e08cab',
    name: 'Two-Factor_Authentication (2FA) Code',
    tags: ["Others"],
    content: `Hi {{name}},\n\nFor added security, please use the following code to complete your login:\n\n🔑 **Your Code**: [Authentication Code]\n\nIf you did not request this, please contact our support team immediately at (support_method).`,
    category: 'AUTHENTICATION',
    language: 'English',
    footer: null,
    buttons: [{"type": "copy_code", "parameter": {"text": null, "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: null,
  },

  {
    id: '6768c57d13bdab8ef5e08cac',
    name: 'Login_Verification',
    tags: ["Others"],
    content: `Hi {{name}},\n\nTo verify your login attempt, please enter the following code in the app or website:\n\n🔑 **Your Code**: [Verification Code]\n\nThis code will expire in **[Time Duration]**.\nPlease do not share this code with anyone for your safety.\n\nIf this wasn’t you, please reset your password or contact our support team at (support_method)`,
    category: 'AUTHENTICATION',
    language: 'English',
    footer: `This code expires in 10 minutes.`,
    buttons: [{"type": "copy_code", "parameter": {"text": null, "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: null,
  },

  {
    id: '6768c57d13bdab8ef5e08c6d',
    name: 'Pre-Travel_Reminder',
    tags: ["Travel"],
    content: `Hi [Customer Name],\n\nYour exciting trip to [Destination] is just around the corner! 🌍 Here’s a quick reminder of your travel details:\n\n✈️ Flight: [Flight Number]\n\n📅 Departure Date: [Departure Date]\n\n🏨 Hotel: [Hotel Name]\n\nMake sure to pack everything you need and arrive at the airport at least [Hours] before your flight. If you have any questions or need to make changes to your booking, we’re just a message away!\n\nSafe travels,\n\n[Your Company Name]`,
    category: 'UTILITY',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [{"type": "url", "parameter": {"text": "Visit us", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: null,
  },

  {
    id: '6768c57d13bdab8ef5e08c6b',
    name: 'Prescription_Renewal_Reminder',
    tags: ["Healthcare"],
    content: `Hi {{name}},\n\nThis is a friendly reminder that it’s time to renew your prescription for [Medication Name]. To ensure you don’t run out of your medication, please submit a renewal request before [Date].\n\n👉 Click here to request your prescription renewal: [Link]\n\nIf you need any assistance, feel free to contacts us at (support_method).`,
    category: 'UTILITY',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [{"type": "url", "parameter": {"text": "Visit us", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: null,
  },

  {
    id: '6768c57d13bdab8ef5e08c6c',
    name: 'Booking_Confirmation',
    tags: ["Travel"],
    content: `Hi [Customer Name],\n\nGreat news! Your trip to [Destination] is confirmed! 🎉 Here are your booking details:\n\n🌍 Destination: [Destination Name]\n\n📅 Travel Dates: [Start Date] - [End Date]\n\n✈️ Flight Number: [Flight Number]\n\n🏨 Hotel: [Hotel Name]\n\n👉 You can access your full itinerary here: [Link]\n\nIf you have any questions or need further assistance, feel free to reply to this message or contact us at [Phone Number].\n\nSafe travels and thank you for choosing [Travel Agency Name]!`,
    category: 'UTILITY',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [{"type": "url", "parameter": {"text": "Visit us", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: null,
  },

  {
    id: '6768c57d13bdab8ef5e08c60',
    name: 'Order_Shipped_Notification',
    tags: ["E-Commerce"],
    content: `Hi {{name}},\n\nGreat news! Your order #[Order Number] has been shipped and is on its way to you.\n\nYou can track your delivery here: [Link]\n\nHere’s what’s on the way:\n\n🛍️ [Product Name]\n\n🛍️ [Product Name]\n\nThank you for shopping with [Your Company Name]! We hope you enjoy your purchase.`,
    category: 'UTILITY',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [{"type": "url", "parameter": {"text": "Visit us", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}, {"type": "quick_reply", "parameter": {"text": "[Your quick reply text]", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: null,
  },

  {
    id: '6768c57d13bdab8ef5e08c62',
    name: 'Payment_Receipt',
    tags: ["E-Commerce"],
    content: `Hi {{name}},\n\nYour payment of [Amount] for order #[Order Number] has been successfully received.\n\nThank you for your purchase! We’ll keep you updated on the status of your order.\n\nYou can view your receipt and order details here: [Link]\n\nNeed help? (support_method)`,
    category: 'UTILITY',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [{"type": "url", "parameter": {"text": "Visit us", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}, {"type": "quick_reply", "parameter": {"text": "[Your quick reply text]", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: null,
  },

  {
    id: '6768c57d13bdab8ef5e08c68',
    name: 'Appointment_Confirmation',
    tags: ["Healthcare"],
    content: `Hi {{name}},\n\nYour appointment with [Doctor’s Name/Department] at [Clinic/Hospital Name] on [Date] at [Time] is confirmed.\n\n✨ Appointment Details:\n\nDoctor: [Doctor's Name]\nDate: [Date]\nTime: [Time]\nLocation: [Clinic Address]\n\nIf you need to reschedule or cancel, contact us at (support_method).\n\nWe look forward to seeing you and helping with your health concerns.`,
    category: 'UTILITY',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [{"type": "url", "parameter": {"text": "Visit us", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: null,
  },

  {
    id: '6768c57d13bdab8ef5e08c6a',
    name: 'Lab_Test_Result_Notification',
    tags: ["Healthcare"],
    content: `Hi {{name}},\n\nYour lab results from your recent tests at [Clinic/Hospital Name] are now ready for viewing.\n\n👉 Click here to view your results securely: [Link]\n\nIf you have any questions or would like to schedule a follow-up consultation with your doctor, feel free to contact us at (support_method).\n\nThank you for choosing [Clinic/Hospital Name] for your healthcare needs.`,
    category: 'UTILITY',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [{"type": "url", "parameter": {"text": "Visit us", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: null,
  },

  {
    id: '6768c57d13bdab8ef5e08c64',
    name: 'Abandoned_Cart_Reminder',
    tags: ["E-Commerce"],
    content: `Hi {{name}},\n\nWe noticed you left something behind in your cart! 👀\n\nDon’t miss out on your [Product Name]. Complete your purchase now and get [Offer/Discount] on your order.\n\nWant to discover more products? Check out our collections!\n\n👉 Complete your purchase here: [Link]\n\nNeed help? Feel free to contact us at [support_method].`,
    category: 'UTILITY',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [{"type": "url", "parameter": {"text": "Visit us", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: null,
  },

  {
    id: '6768c57d13bdab8ef5e08c66',
    name: 'Students_Welcome_Message',
    tags: ["Education"],
    content: `Dear {{name}},\n\nWelcome to the **[School/College Name]** family! We’re thrilled to have you join us for an exciting academic journey ahead.\n\nTo help you get started, here are some important details:\n\n- Orientation Date: [Date]\n- Class Start Date: [Date]\n- [Any Additional Information]\n\n👉 Access your student portal here: [Link]\n\nIf you have any questions or need guidance, don’t hesitate to reply to this message or reach out to us at (support_method)`,
    category: 'UTILITY',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [{"type": "url", "parameter": {"text": "Visit us", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: null,
  },

  {
    id: '6768c57d13bdab8ef5e08c5f',
    name: 'Order_Confirmation',
    tags: ["E-Commerce"],
    content: `Hi {{name}},\n\nThank you for shopping with us! Your order #[Order Number] has been confirmed.\n\nHere’s a summary of your purchase:\n\n🛍️ <Product Name>\n\n🛍️ [Product Name]\n\nYour order will be shipped soon. You can track your order status here: [Link]\n\nHave any questions about your order? Feel free to contact us at <support method>!\n\nThanks again for choosing [Your Company Name]!`,
    category: 'UTILITY',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [{"type": "url", "parameter": {"text": "Visit us", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}, {"type": "quick_reply", "parameter": {"text": "[Your quick reply text]", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: null,
  },

  {
    id: '6768c57d13bdab8ef5e08c69',
    name: 'Appointment_Reminder',
    tags: ["Healthcare"],
    content: `Hi {{name}},\n\nThis is a quick reminder of your appointment with [Doctor’s Name/Department] at [Clinic/Hospital Name] tomorrow, [Date], at [Time].\n\nMake sure to arrive 10 minutes early to ensure a smooth check-in process.\n\n👉 If you need to reschedule, <link>/contact us (support_method).\n\nThank you, and we look forward to seeing you!`,
    category: 'UTILITY',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [{"type": "url", "parameter": {"text": "Visit us", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: null,
  },

  {
    id: '6768c57d13bdab8ef5e08c61',
    name: 'Order_Delivered_Confirmation',
    tags: ["E-Commerce"],
    content: `Hi {{name}},\n\nYour order #[Order Number] has been delivered! We hope you’re loving your new items.\n\nIf you have any questions or concerns about your order, feel free to contact us at (support_method). We’re always happy to help!\n\nThank you for choosing [Your Company Name]. We look forward to serving you again!`,
    category: 'UTILITY',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [{"type": "url", "parameter": {"text": "Visit us", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}, {"type": "quick_reply", "parameter": {"text": "[Your quick reply text]", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: null,
  },

  {
    id: '6768c57d13bdab8ef5e08c63',
    name: 'Order_Support_Inquiry',
    tags: ["E-Commerce"],
    content: `Hi {{name}},\n\nThank you for reaching out to us. We’ve received your inquiry regarding your order #[Order Number], and we want you to know that we’re on it! 👀\n\nOur team is currently reviewing the details of your request, and we’ll make sure to get back to you with a resolution as soon as possible.\n\nIn the meantime, if you have any additional information or questions about your order, feel free to contact us at (support_method). We’re here to help you every step of the way! 😊\n\nThank you for your patience and for choosing [Your Company Name].`,
    category: 'UTILITY',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [{"type": "url", "parameter": {"text": "Visit us", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}, {"type": "quick_reply", "parameter": {"text": "[Your quick reply text]", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: null,
  },

  {
    id: '6768c57d13bdab8ef5e08c65',
    name: 'Course_Enrollment_Confirmation',
    tags: ["Education"],
    content: `Hi {{name}},\n\nCongratulations on enrolling in **[Course Name]**! We’re excited to have you on board. 🚀\n\nHere’s what you can expect:\n\n- Course Start Date: [Start Date]\n- Duration: [Duration]\n- Course Access: [Link to Course Platform]\n\nGet ready to dive into [Topic/Text] and start learning at your own pace! If you have any questions or need assistance, (support_method).\n\nWe look forward to seeing your progress!`,
    category: 'UTILITY',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [{"type": "url", "parameter": {"text": "Visit us", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: null,
  },

  {
    id: '6768c57d13bdab8ef5e08c67',
    name: 'Class_Reminder',
    tags: ["Education"],
    content: `Hi {{name}},\n\nThis is a reminder that your class for **[Course Name]** is scheduled for tomorrow, **[Date]** at **[Time]**.\n\nBe sure to log in a few minutes early to ensure everything is set up!\n\n👉 Access your class here: [Link]\n\nNeed help or have any questions? (support_method)\n\nWe look forward to seeing you in class!`,
    category: 'UTILITY',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [{"type": "url", "parameter": {"text": "Visit us", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: null,
  },

  {
    id: '6768c57d13bdab8ef5e08c0e',
    name: 'Course_Promotion',
    tags: ["Education"],
    content: `Hi {{name}},\n\nWe’re excited to announce our brand-new courses: **[Course names]**! 🎓\n\nDesigned by industry experts, this course will equip you with [Skills/Knowledge Area] and prepare you for [Career Path/Outcome].\nCheck out our course catalog to learn more.\nEnroll now and get a [Discount/Free Trial/Offer] if you sign up before [Date]!\n👉 Sign up here: [Link]\n`,
    category: 'MARKETING',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [{"type": 5, "parameter": {"text": "View catalog", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 1, "typeString": "text", "text": "New Courses Alert! ", "link": null, "mediaHeaderId": null, "mediaFromPC": null, "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '6768c57d13bdab8ef5e08c11',
    name: 'Admission_Open',
    tags: ["Education"],
    content: `Dear Parents and Students,\n\nWe are pleased to announce that admissions for the **[Academic Year]** at **[School/College Name]** are now open!\n\n✨ Why Choose Us?\n\n- [Highlight key feature 1 – e.g., experienced faculty]\n- [Highlight key feature 2 – e.g., modern infrastructure]\n- [Highlight key feature 3 – e.g., focus on holistic education]\n\nSeats are filling up fast! Don’t miss the opportunity to enroll your child in one of the leading educational institutions.\n\n👉 To apply or schedule a visit, click here: [Link]\n\nFor more details, contact us at [contact details]`,
    category: 'MARKETING',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [{"type": "url", "parameter": {"text": "Visit us", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}, {"type": "quick_reply", "parameter": {"text": "[Your quick reply text]", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}, {"type": 6, "parameter": {"text": "Copy offer code", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 1, "typeString": "text", "text": "Admissions Now Open for [Academic Year]! ", "link": null, "mediaHeaderId": null, "mediaFromPC": null, "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '6768c57d13bdab8ef5e08c14',
    name: 'Special_Travel_Promotions',
    tags: ["Travel"],
    content: `Hi {{name}},\n\nReady for your next adventure? 🌍 We’ve got amazing deals for you to explore some of the most beautiful destinations around the world!\n🔥 Special Offers:\n[Destination Name]: [Discount Offer]\n[Destination Name]: [Discount Offer]\n[Destination Name]: [Discount Offer]\n👉 Book now and save big: [Link]\nWant to learn more? Check out our website [link]\n`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [{"type": "url", "parameter": {"text": "I want to know more", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}, {"type": "quick_reply", "parameter": {"text": "[Your quick reply text]", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 1, "typeString": "text", "text": "Amazing places you can travel this year! ", "link": null, "mediaHeaderId": null, "mediaFromPC": null, "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '6768c57d13bdab8ef5e08c0d',
    name: 'Course_Promotion',
    tags: ["Education"],
    content: `Hi {{name}},\n\nWe’re excited to announce our brand-new course: **[Course Name]**! 🎓\n\nDesigned by industry experts, this course will equip you with [Skills/Knowledge Area] and prepare you for [Career Path/Outcome].\n\n✨ What you’ll learn:\n\n- [Key Learning Point 1]\n- [Key Learning Point 2]\n- [Key Learning Point 3]\n\nEnroll now and get a [Discount/Free Trial/Offer] if you sign up before [Date]!\n\n👉 Sign up here: [Link]\n\n`,
    category: 'MARKETING',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [{"type": "url", "parameter": {"text": "Visit us", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}, {"type": "quick_reply", "parameter": {"text": "[Your quick reply text]", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}, {"type": 6, "parameter": {"text": "Copy offer code", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 1, "typeString": "text", "text": "New Course Alert! ", "link": null, "mediaHeaderId": null, "mediaFromPC": null, "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '6768c57d13bdab8ef5e08c15',
    name: 'Special_Travel_Promotions',
    tags: ["Travel"],
    content: `Hi {{name}},\nReady for your next adventure? 🌍 \nThis is the best season for you to visit <place_name>! \n🔥 Special Offers:\n[Destination Name]: [Discount Offer]\n[Destination Name]: [Discount Offer]\n[Destination Name]: [Discount Offer]\n👉 Hurry, book now and save big: [Link]"                                  \n📅 This offer ends in just [Number of Hours/Days]. Don’t wait!\nWant to learn more? Check out our website [link]\n`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [{"type": 6, "parameter": {"text": "Copy offer code", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}, {"type": "url", "parameter": {"text": "Visit us", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 1, "typeString": "text", "text": "Limited-Time Offer\u2014Don\u2019t Miss Out! ", "link": null, "mediaHeaderId": null, "mediaFromPC": null, "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '6768c57d13bdab8ef5e08c12',
    name: 'Health_Checkup_Promotion',
    tags: ["Healthcare"],
    content: `Hi {{name}},\n\nYour health is your most valuable asset, and regular checkups are key to maintaining it. We’re offering a special promotion on our comprehensive health checkups this month!\n\n✨ Health Checkup Includes:\n\n[Test/Screening 1]\n[Test/Screening 2]\n[Test/Screening 3]\n\n👉 Book your checkup today and get [Discount/Offer]: [Link]\nFor more details, contact us at [contact details]\nTake control of your health today!`,
    category: 'MARKETING',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [{"type": "url", "parameter": {"text": "Visit us", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}, {"type": "quick_reply", "parameter": {"text": "[Your quick reply text]", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}, {"type": 6, "parameter": {"text": "Copy offer code", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 1, "typeString": "text", "text": "Get Your Annual Health Checkup! ", "link": null, "mediaHeaderId": null, "mediaFromPC": null, "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '6768c57d13bdab8ef5e08c16',
    name: 'Special_Travel_Promotions',
    tags: ["Travel"],
    content: `Hi {{name}},\n\nReady for your next adventure? 🌍 We’ve got amazing deals for you to explore some of the most beautiful destinations around the world!\n🔥 Special Offers:\n[Destination Name]: [Discount Offer]\n[Destination Name]: [Discount Offer]\n[Destination Name]: [Discount Offer]\nFor more details, chedck out our catalog below.\n👉 Book now and save big: [Link]\nWant to learn more? Check out our website [link]\n`,
    category: 'MARKETING',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [{"type": 5, "parameter": {"text": "View catalog", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 1, "typeString": "text", "text": "Amazing places you can travel this year! ", "link": null, "mediaHeaderId": null, "mediaFromPC": null, "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '6768c57d13bdab8ef5e08c13',
    name: 'Special_Travel_Promotions',
    tags: ["Travel"],
    content: `Hi {{name}},\n\nReady for your next adventure? 🌍 We’ve got amazing deals for you to explore some of the most beautiful destinations around the world!\n🔥 Special Offers:\n[Destination Name]: [Discount Offer]\n[Destination Name]: [Discount Offer]\n[Destination Name]: [Discount Offer]\n👉 Book now and save big: [Link]\nWant to learn more? Check out our website [link]\n`,
    category: 'MARKETING',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [{"type": "url", "parameter": {"text": "Visit us", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}, {"type": "quick_reply", "parameter": {"text": "[Your quick reply text]", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}, {"type": 6, "parameter": {"text": "Copy offer code", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 1, "typeString": "text", "text": "Explore the World with Our Special Offers! ", "link": null, "mediaHeaderId": null, "mediaFromPC": null, "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '6768c57d13bdab8ef5e08c0f',
    name: 'Course_Promotion',
    tags: ["Education"],
    content: `🎓 Take your skills to the next level with our exclusive [Skill/Subject] courses!\n💡 Enroll now and save [XX]% for a limited time.\n\n✅ Expert-led lessons\n✅ Flexible schedules\n✅ Certification guaranteed\n\n⏳ Offer expires on [Date] – Don't wait!`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [{"type": 6, "parameter": {"text": "Copy offer code", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}, {"type": "url", "parameter": {"text": "Visit us", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 1, "typeString": "text", "text": "Master [Skill/Subject] with [XX]% OFF!", "link": null, "mediaHeaderId": null, "mediaFromPC": null, "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '6768c57d13bdab8ef5e08c10',
    name: 'Course_Completion',
    tags: ["Education"],
    content: `Hi {{name}},\n\nCongratulations on successfully completing **[Course Name]**! 🎉 We’re proud of your achievement and the hard work you’ve put into your learning.\n\nYou’ve earned a certificate in [Skill/Text], and it’s ready for download!\n\n👉 Download your certificate here: [Link]\n\nWhat’s next? Check out our advanced courses to continue your learning journey: [Link to Courses].\n\nWell done, and we look forward to seeing you achieve even more!`,
    category: 'MARKETING',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [{"type": "url", "parameter": {"text": "Visit us", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}, {"type": "quick_reply", "parameter": {"text": "[Your quick reply text]", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}, {"type": 6, "parameter": {"text": "Copy offer code", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 1, "typeString": "text", "text": "Congratulations! You\u2019ve Completed Your Course ", "link": null, "mediaHeaderId": null, "mediaFromPC": null, "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '6768c57d13bdab8ef5e08c05',
    name: 'Product_Sales_announcement',
    tags: ["E-Commerce"],
    content: `Hi {{name}},\n\nWe’re excited to announce the launch of our brand-new [Collection Name] collection! 🎉\n\n✨ [Product Feature 1]\n\n✨ [Product Feature 2]\n\n✨ [Special Offer or Limited Availability]\n\nBe among the first to get your hands on our latest products and enjoy [Launch Offer].\n\n👉 Shop now: [Link]\n\n`,
    category: 'MARKETING',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [{"type": "url", "parameter": {"text": "Visit us", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}, {"type": "quick_reply", "parameter": {"text": "[Your quick reply text]", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}, {"type": 6, "parameter": {"text": "Copy offer code", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 1, "typeString": "text", "text": "Introducing Our Latest Collection! ", "link": null, "mediaHeaderId": null, "mediaFromPC": null, "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '6768c57d13bdab8ef5e08c08',
    name: 'Product_Sales_announcement',
    tags: ["E-Commerce"],
    content: `Hi {{name}},\n\nWe’re excited to introduce our latest collection! 🎉 Check out our collections to explore the new arrivals and find your favorite pieces. Each product has been designed with you in mind, offering style, comfort, and quality.\n✨ Discover more from our new collection by swiping through each card! `,
    category: 'MARKETING',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [{"type": 5, "parameter": {"text": "View catalog", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}, {"type": "quick_reply", "parameter": {"text": "[Your quick reply text]", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}, {"type": 6, "parameter": {"text": "Copy offer code", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 1, "typeString": "text", "text": "Massive Discounts! Dive into our collections! ", "link": null, "mediaHeaderId": null, "mediaFromPC": null, "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '6768c57d13bdab8ef5e08c09',
    name: 'Seasonal_event_templates (to be a part of existing festival templates)',
    tags: ["E-Commerce"],
    content: `Hi {{name}},\n\nThis [Event/Holiday], treat yourself or your loved ones to something special! ❤️\n\nEnjoy exclusive discounts on our [Product Category] with [Offer/Discount] until [End Date].\n\n✨ Free Shipping on all orders\n\n✨ Gift wrapping available for that extra special touch\nCheck out our catalog to browse through our collections!\n\n👉 Shop the [Event/Holiday] collection here: [Link]\n\nHappy [Event/Holiday] from all of us at [Your Company Name]! 🎉`,
    category: 'MARKETING',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [{"type": 5, "parameter": {"text": "View catalog", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 1, "typeString": "text", "text": "Celebrate [Event/Holiday] with Special Offers! ", "link": null, "mediaHeaderId": null, "mediaFromPC": null, "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '6768c57d13bdab8ef5e08c0a',
    name: 'Seasonal_event_templates (to be a part of existing festival templates)',
    tags: ["E-Commerce"],
    content: `    Hi {{name}},\n    \n    This [Event/Holiday], don’t miss our flash sale! Save up to [Discount]% for a limited time only.\n    \n    🕒 Hurry, sale ends at [Time/Date]!\n    \n    👉 Grab the deal here: [Link]\n    \n `,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [{"type": 6, "parameter": {"text": "Copy offer code", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}, {"type": "url", "parameter": {"text": "Visit us", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 1, "typeString": "text", "text": "[Event/Holiday] Flash Sale! Only a Few Hours Left! ", "link": null, "mediaHeaderId": null, "mediaFromPC": null, "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '6768c57d13bdab8ef5e08c0b',
    name: 'Seasonal_event_templates (to be a part of existing festival templates)',
    tags: ["E-Commerce"],
    content: `Hi {{name}},\nSwipe through to check out our collections now!\nThis [Event/Holiday], treat yourself or your loved ones to something special! ❤️\n\nEnjoy exclusive discounts on our [Product Category] with [Offer/Discount] until [End Date].\n\n✨ Free Shipping on all orders\n\n✨ Gift wrapping available for that extra special touch\n\n👉 Shop the [Event/Holiday] collection here: [Link]\n\nHappy [Event/Holiday] from all of us at [Your Company Name]! 🎉`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [{"type": "url", "parameter": {"text": "I want to know more", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}, {"type": "quick_reply", "parameter": {"text": "[Your quick reply text]", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 1, "typeString": "text", "text": "Celebrate [Event/Holiday] with Special Offers! ", "link": null, "mediaHeaderId": null, "mediaFromPC": null, "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '6768c57d13bdab8ef5e08c07',
    name: 'Product_Sales_announcement',
    tags: ["E-Commerce"],
    content: `Hi {{name}},\nFor a limited time only, enjoy [Discount/Offer] on all your favorite products from [Product Category]! 🎉\n\n📅 This offer ends in just [Number of Hours/Days]. Don’t wait—shop now and save big!\n👉 Shop the offer here: [Link]\n\n`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [{"type": 6, "parameter": {"text": "Copy offer code", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}, {"type": "url", "parameter": {"text": "Shop now!", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 1, "typeString": "text", "text": "Limited-Time Offer\u2014Don\u2019t Miss Out! ", "link": null, "mediaHeaderId": null, "mediaFromPC": null, "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '6768c57d13bdab8ef5e08c0c',
    name: 'Back-in-Stock_Notification',
    tags: ["E-Commerce"],
    content: `Hi {{name}},\n\nGood news! The item you’ve been waiting for—[Product Name]—is back in stock! 🙌\n\nThey’ve been flying off the shelves, so don’t miss out this time!\n\nHave any questions? Feel free to contact us at (support_method), and we’ll be happy to help!`,
    category: 'MARKETING',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [{"type": 5, "parameter": {"text": "View catalog", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 1, "typeString": "text", "text": "Your Favorite Items are Back in Stock! ", "link": null, "mediaHeaderId": null, "mediaFromPC": null, "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '6768c57d13bdab8ef5e08c06',
    name: 'Product_Sales_announcement',
    tags: ["E-Commerce"],
    content: `Hi {{name}},\n\nWe’re excited to introduce our latest collection! 🎉 Swipe through our collections below to explore the new arrivals. Each product has been designed keeping style, comfort, and quality in mind.\n✨ Find your favorite piece by swiping through each card! `,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [{"type": "url", "parameter": {"text": "I want to know more [Visit the store]", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}, {"type": "quick_reply", "parameter": {"text": "[Your quick reply text]", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 1, "typeString": "text", "text": "Swipe Through Our Latest Collection! ", "link": null, "mediaHeaderId": null, "mediaFromPC": null, "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '65c1cb53bb422d2f628f60cc',
    name: 'lny_greetings',
    tags: ["Festival"],
    content: `🎉 Happy Lunar New Year {{name}}! 🎉\n\nWishing you joy, prosperity, and good fortune in the Year of the Dragon! 🐲🏮✨\n\nMay this year bring: \n🌟 Blessings \n🌸 Health \n💰 Prosperity \n🎊 Joy\n\n[Your name]`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [],
    header: null,
  },

  {
    id: '65c1cb7cbb422d2f628f60ce',
    name: 'lunar_new_year',
    tags: ["Festival"],
    content: `Dear {{name}},\n\nCelebrate the Year of the Dragon 🐉 with us! \n\nEnjoy [Discount Percentage]% off your next purchase with code: LUNAR10\n\n🛍️ Shop now at [Your Store Name]. Offer ends [Expiry Date].\n\nWishing you joy and prosperity!\n[Your company name]`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [],
    header: null,
  },

  {
    id: '659d29c59b71ba0b34390baf',
    name: 'republic_day_discount',
    tags: ["Festival"],
    content: `🇮🇳 Happy Republic Day {{name}}! 🇮🇳\n\nCelebrate the pride of our nation with a special Republic Day offer! 🎉 Use code: REPUBLIC20 to enjoy a 20% discount on your purchase.\n\n🛍️ Shop now and embrace the spirit of freedom and savings. This offer is valid until [expiry date].\n\nWishing you a joyful Republic Day filled with patriotism and prosperity!\nJai Hind! 🙏🏻✨\n[Your Shop Name]`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [],
    header: null,
  },

  {
    id: '659d285a9b71ba0b34390bab',
    name: 'republic_day_general',
    tags: ["Festival"],
    content: `🇮🇳 Happy Republic Day {{name}}! 🇮🇳\n\nOn this proud occasion, let's salute the spirit of unity and diversity that defines our great nation.\n\nWishing you a joyous Republic Day filled with pride and patriotism. Let's celebrate the values that make India extraordinary!\n\nJai Hind! 🙏🏻✨\n[Your Shop Name]`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [],
    header: null,
  },

  {
    id: '659d0b15b7311566bbfd8c7b',
    name: 'makar_sankranti_general',
    tags: ["Festival"],
    content: `🌾✨ Happy Makar Sankranti! 🪁🌞\n\nWishing you {{name}} and your loved ones a joyous and prosperous Makar Sankranti! May the sun radiate peace, happiness, and success in your life.\n\nAs the kites soar high, may your spirits soar higher. Have a wonderful celebration filled with warmth and togetherness!\n\nBest wishes, [Your Shop Name]`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [],
    header: null,
  },

  {
    id: '659d0ac1b7311566bbfd8c79',
    name: 'makar_sankranti_offer',
    tags: ["Festival"],
    content: `{{name}}\n\n🌟 Happy Makar Sankranti! 🪁✨\n\nCelebrate the joy of the season with us! 🎉 Avail a special 20% discount on your purchase using code: MAKAR20.\n\n🛍️ Shop now and enjoy the festive savings! 🪅\n[Your Shop Name]`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [],
    header: null,
  },

  {
    id: '653675d49749b3ee73d30356',
    name: '1212_sales_last_chance',
    tags: ["E-Commerce"],
    content: `🕒 Last Chance Alert! 12:12 Sales Ending Soon! 🚨\n🛍️ Time's ticking down on the year's biggest sale! 🎁\n🌟 Grab these amazing deals before they vanish:\n\n💰 Up to 60% off!\n🎁 Unbelievable offers!\n🚚 Swift shipping for your treasures!\n\n📅 Date: Dec 12 🕒 Last moments are here!\n📍 Start shopping: 🌐 [Your Website URL]\n💬 Questions? We're here for you by responding to this message\n🛒 Don't miss out! This sale is disappearing in a flash! 💨`,
    category: 'MARKETING',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [{"type": "url", "parameter": {"text": "Shop now", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: null,
  },

  {
    id: '653673a09749b3ee73d30342',
    name: '1212_sales_alert',
    tags: ["E-Commerce"],
    content: `🎉 12:12 Flash Sale Alert! 🎉\n\n🛍️ Ready, Set, Shop! It's the biggest sale of the year! 🎁\n🌟 What's in store for you:\n💰 Up to 60% off!\n🎁 Unbelievable deals!\n🚚 Lightning-fast shipping!\n\n📅 Date: Dec 12 🕒 All day long!\n📍 Shop now: 🌐 [Your Website URL]\n💬 Need assistance? Reach out at [Your Contact Number].\n🛒 Hurry, the clock's ticking! Get your holiday shopping groove on! 🎅`,
    category: 'MARKETING',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [{"type": "url", "parameter": {"text": "Shop now", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: null,
  },

  {
    id: '65366ee3aa1da39f74b18c80',
    name: 'singles_day_sale_end',
    tags: ["E-Commerce"],
    content: `🎉 Last Chance Singles' Day Sale! 🎉\n\n⏰ It's almost over! Our Singles' Day sale is ending soon, but you still have time to grab amazing deals:\n1️⃣ Up to [Discount Percentage]% off on selected items! \n2️⃣ Buy one, get one free on [Product]! \n3️⃣ Exclusive Singles' Day offer: [Product] for just [Discounted Price]!\n\n🛒 Don't miss out! Shop now before it's too late.\n💬 Share this message with your friends and family so they can enjoy the savings too! 👨‍👩‍👧‍👦\nHappy Shopping! 🛍️🎁`,
    category: 'MARKETING',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [{"type": "url", "parameter": {"text": "Shop now", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 2, "typeString": "image", "text": null, "link": "", "mediaHeaderId": "589868313205487", "mediaFromPC": "7977929-b4faa58c-1fd2-45bf-ad9b-30224ab27eaa.jpg", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '65366c46aa1da39f74b18c7e',
    name: 'singles_day_sale',
    tags: ["E-Commerce"],
    content: `🎉 Happy Singles' Day! 🎉\n\n🛍️ It's 11.11 - Shop amazing deals today:\n1️⃣ Up to [Discount Percentage]% off at [Your Store Name]. \n2️⃣ Buy one, get one free on [Product]! \n3️⃣ [Product] for just [Discounted Price]!\n\n🕒 Limited time offers. Don't miss out!\n📦 Shop now and treat yourself! 💃🕺\nHappy Singles' Day! 🛍️🎁`,
    category: 'MARKETING',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [{"type": "url", "parameter": {"text": "Shop now", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 2, "typeString": "image", "text": null, "link": "", "mediaHeaderId": "589868313205487", "mediaFromPC": "7977929-b4faa58c-1fd2-45bf-ad9b-30224ab27eaa.jpg", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '65366abaaa1da39f74b18c7c',
    name: 'diwali_last_call',
    tags: ["Festival"],
    content: `🪔 Last Call Diwali Sale! 🪔\n\n⏰ Hurry, Diwali deals are ending soon:\n1️⃣ Up to [Discount Percentage]% off at [Your Store Name]. 2️⃣ Last chance for [Discount Percentage]% off [Product]! 3️⃣ [Product] now [Discounted Price] - Diwali special!\n\n🕒 Don't miss out! Grab your favourites.\nShare the joy! 🪔🎁`,
    category: 'MARKETING',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [{"type": "url", "parameter": {"text": "Shop now", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 2, "typeString": "image", "text": null, "link": "", "mediaHeaderId": "834799694799212", "mediaFromPC": "Diwali_sale-84f70543-a625-4e10-9826-d490be508362.jpg", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '65366a51aa1da39f74b18c7a',
    name: 'diwali_mega_sale',
    tags: ["Festival"],
    content: `🪔✨ Diwali Mega Sale! ✨🪔\n\n🎉 Celebrate Diwali with Spectacular Savings at [Your Store Name]!\n\n🌟 Use Code: DIWALI20 for [X]% Off Your Entire Purchase! 🌟\n🚚 Enjoy FREE SHIPPING on all Diwali orders! 🎁\n🛒 Shop now at [Website URL] to avail of these amazing deals and make your Diwali celebrations extra special.\n💥 Hurry! Sale ends on [End Date]. Don't miss out on the savings and free shipping! 💥\n\nWishing you a joyful and prosperous Diwali!\n[Your Contact Information]`,
    category: 'MARKETING',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [{"type": "url", "parameter": {"text": "Shop now", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 2, "typeString": "image", "text": null, "link": "", "mediaHeaderId": "834799694799212", "mediaFromPC": "Diwali_sale-84f70543-a625-4e10-9826-d490be508362.jpg", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '653669fbaa1da39f74b18c78',
    name: 'diwali_sale_now',
    tags: ["Festival"],
    content: `🪔✨ Diwali Sale Happening Now! ✨🪔\n\n🎉 Celebrate Diwali with big savings at [Your Online Shop]!\n🌟 Current Diwali Offer: 🎁 Get [X]% off on all items! 📆 Limited time offer!\n🛒 Shop online at [Website URL] and grab your Diwali essentials today.\n\n💥 Don't wait - shop now and save big this Diwali! 💥\n\nHappy Diwali!\n[Your Contact Information]`,
    category: 'MARKETING',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [{"type": "url", "parameter": {"text": "Shop now", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 2, "typeString": "image", "text": null, "link": "", "mediaHeaderId": "834799694799212", "mediaFromPC": "Diwali_sale-84f70543-a625-4e10-9826-d490be508362.jpg", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '653667b1aa1da39f74b18c6e',
    name: 'diwali_presale',
    tags: ["Festival"],
    content: `🪔✨ Diwali Sale Alert! ✨🪔\n\n🛍️ Get ready for huge savings this Diwali at [Your Online Shop]!\n\n🌟 Diwali Special Offer: 🎁 Enjoy [X]% off storewide! 📆 Sale starts on [Start Date]!\n🎉 Shop online at [Website URL] and use code "DIWALI[X]" at checkout to avail the discount.\n💥 Don't miss out on these exclusive Diwali deals! 💥\n🤩 Share the joy with your loved ones! Happy Diwali!\n\n[Your Contact Information]`,
    category: 'MARKETING',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [{"type": "url", "parameter": {"text": "Shop now", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 2, "typeString": "image", "text": null, "link": "", "mediaHeaderId": "834799694799212", "mediaFromPC": "Diwali_sale-84f70543-a625-4e10-9826-d490be508362.jpg", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '6536603eaa1da39f74b18c66',
    name: 'diwali_general',
    tags: ["Festival"],
    content: `🪔 Happy Diwali! 🪔\n\nWishing you and your loved ones a Diwali filled with light, love, and joy. May this festival of lights illuminate your path towards happiness and success.\n\n🕯️ Let's celebrate the triumph of light over darkness and good over evil together. 🌟\n\nMay your home be filled with warmth and your heart with gratitude. Happy Diwali!\n[Your Name/Organization]`,
    category: 'MARKETING',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [],
    header: {"type": 2, "typeString": "image", "text": null, "link": "", "mediaHeaderId": "633081218998821", "mediaFromPC": "Diwali-0dec87df-2b55-46e4-b8f7-c9a5824834f0.jpg", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '653653fcaa1da39f74b18c52',
    name: 'dhanteras',
    tags: ["Festival"],
    content: `🪔 Celebrate Dhanteras with Us! 🛍️\n\nDiscover the treasures of Dhanteras at [Your Online Shop Name]!\n\n🌟 Shop with us this auspicious day and bring home prosperity: \n🪙 Exclusive Dhanteras discounts on all products! \n🎁 Free shipping on Dhanteras special collections!\n\nVisit our website [Website Link] now and fill your cart with happiness and blessings.\nWishing you a wealth-filled Dhanteras! 🪔✨`,
    category: 'MARKETING',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [],
    header: {"type": 2, "typeString": "image", "text": null, "link": "", "mediaHeaderId": "6970365489673293", "mediaFromPC": "Dhanteras-7df9be02-d1bb-4274-90b2-3127782299c9.jpg", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '6536524aaa1da39f74b18c4c',
    name: 'cheat_sheets',
    tags: ["E-Commerce"],
    content: `🌟 Exclusive Early Access & Preview Sale Alert! 🛍️\n\nHey there, valued shopper!\n\nWe're thrilled to offer you a special treat - early access and a sneak peek into our upcoming Preview Sale event! 🎉\n\n📅 Event Date: [Event Date] 🕒 Early Access Start: [Early Access Start Time]\n\nGet ready to: 💰 Enjoy exclusive discounts on your favourite products. \n👀 Get a first look at our exciting new collections. \n🎁 Snag fantastic deals and offers.\n\nMark your calendar, set your alarms, and be prepared to indulge in a shopping experience like never before! This is your chance to shop smart and get a head start on your wishlist. 🛒💃\n\nStay tuned for more details and surprises coming your way!\nWe can't wait to see you at our Preview Sale! 🛍️✨`,
    category: 'MARKETING',
    language: 'English',
    footer: `Powered by wati.io`,
    buttons: [],
    header: null,
  },

  {
    id: '672cf050a8654bcb52d8fbe3',
    name: 'christmas_wishes',
    tags: ["Festival"],
    content: `Hi {{name}}! 🎄🎅\n\nWishing you a joyful and magical Christmas season! \n\nMay this festive season bring you and your loved ones endless happiness and countless blessings. Thank you for being our beloved customer!\n\nMerry Christmas and a Happy New Year! 🎉✨\n\nWarmest wishes,\n{{shop_name}}`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [],
    header: null,
  },

  {
    id: '672cf0b4b514c8599b9aa2a4',
    name: 'christmas_wishes_pt',
    tags: ["Festival"],
    content: `Olá {{name}}! 🎄🎅\n\nDesejamos a você uma época de Natal alegre e mágica!\n\nQue este momento festivo traga a você e aos seus entes queridos felicidade infinita e inúmeras bênçãos. Agradecemos por ser nosso querido cliente!\nFeliz Natal e um Feliz Ano Novo! 🎉✨\n\nDesejamos-lhe os melhores votos,\n{{shop_name}}`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [],
    header: null,
  },

  {
    id: '672cf1320ed9478095a28528',
    name: 'cybermonday',
    tags: ["Festival"],
    content: `🌐 Cyber Monday Alert! 🚀\n\n🛒 Cyber Monday Madness is here, and it's time to snag the best online deals:\n\n🚀 Up to X% off on everything!\n📦 Free shipping on all orders.\n🎁 Don't miss out on the savings – shop now!\n\n🌐 Grab your devices and let's shop 'til we drop! 💻`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [{"type": "url", "parameter": {"text": "Shop now", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: null,
  },

  {
    id: '672cf18d9e6b678de1133cb1',
    name: 'bfsalesalert',
    tags: ["Festival"],
    content: `🖤 Black Friday Alert! 🛒\n\n🚨 Get ready for the biggest shopping day of the year:\n\n🛍️ Up to X% off storewide!\n🕒 Limited-time deals - don't miss out!\n🎁 Start your holiday shopping today!\n\n📲 Shop online {{url}}  Happy shopping! 🛒🎉`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [{"type": "url", "parameter": {"text": "Shop now", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: null,
  },

  {
    id: '672cf2174560ffd9270494ca',
    name: 'thanksgiving_wishes',
    tags: ["Festival"],
    content: `🍂 Happy Thanksgiving! 🍁\n\nAs we gather with friends and family to count our blessings, I wanted to take a moment to express my gratitude for being a valued customer.\n\n🙏 This Thanksgiving, I'm thankful for the precious moments we've shared, the laughter we've enjoyed, and the support we've given each other.\n\nMay your day be filled with love, joy, and a table full of delicious food. 🦃🥧\n\nWishing you a warm and wonderful Thanksgiving celebration!\n\nWith gratitude,\n{{shop_name}}`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://img.freepik.com/free-photo/thanksgiving-day-banner-with-harvest_23-2149550004.jpg?t=st=1730998734~exp=1731002334~hmac=3cddcd8b035ff2a7edf5a1a2a421090162427cc5f9339b0a1b002d6d97f51fa5&w=1800", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '672cf2a7c013cc1a996cb87e',
    name: 'nye_wishes',
    tags: ["Festival"],
    content: `Hey {{name}}! 🎉🎆\n\nAs we bid farewell to the old year and welcome the new one, we wanted to take a moment to thank you for your support and trust. \n\nWishing you a joyful and prosperous New Year filled with laughter, love, and exciting adventures!🥳✨\n\nBest wishes,\n{{shop_name}}`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://img.freepik.com/free-photo/new-year-background_24972-1409.jpg?t=st=1730998908~exp=1731002508~hmac=9f484971e6d37d12e5b179a0d5eaefd9898b90b9a33d36ce724be43a69a5a4dd&w=1800", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '672cf5a4b514c8599b9aa2a6',
    name: 'new_courses',
    tags: ["Education"],
    content: `🎓 *New Course Available: {{Course_Name}}*\n\nDear {{Name}},\n\nWe’re excited to announce that we are offering a new course: *Course Name*! Here are the details:\n\n- 🗓️ Start Date: {{Date}}\n- ⏰ Duration: {{Time}}\n- 💻 Mode: {{online}}\n- 📚 Key Topics: Topic 1, Topic 2, Topic 3\n- 📝 How to Enroll: {{url}}\n\nSeats are limited, so make sure to enroll as soon as possible. If you have any questions, feel free to reply to this message.\n\nBest regards,\n{{Company_Name}}`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [{"type": "url", "parameter": {"text": "I want to enroll", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: null,
  },

  {
    id: '672cf5e6e280cdf440868147',
    name: 'edu_schedules',
    tags: ["Education"],
    content: `📚 *Good morning, {{Name}}!*\n\nHere’s your schedule for today:\n- Subject 1: {{Time}} - {{Topic}}\n- Subject 2: {{Time}} - {{Topic}}\n- Additional subjects if needed\n\nMaterials required:\n- Material 1\n- Material 2\n\nMake sure you’re prepared! If you have any questions, feel free to ask.\n\nBest of luck! 👍`,
    category: 'UTILITY',
    language: 'English',
    footer: null,
    buttons: [],
    header: null,
  },

  {
    id: '672cf673e280cdf440868148',
    name: 'edu_course_options',
    tags: ["Education"],
    content: `✨ *Why Choose {{Course_Name}}?*\n\nHi {{Name}},\n\nWondering why *{{Course_Name}}* is the right choice for you? Here’s what makes our program stand out:\n\n1. 💡 Expert instructors from {{Industry}}\n2. 🔍 Real-world case studies and hands-on projects\n3. 🎓 Certification from {{Accredited_Institution}}\n4. 🌐 Flexible online learning with personalized support\n\nReady to take the next step? Enroll now: {{url}}\n\nLooking forward to helping you achieve your goals!\n\nBest regards,\n{{Institution_Name}}`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [{"type": "url", "parameter": {"text": "I want to enroll", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: null,
  },

  {
    id: '672cf744e4c5aed482d2ce4e',
    name: 'edu_student_testimonial',
    tags: ["Education"],
    content: `🌟 *Student Success Story: {{Student_Name}}*\n\nHi {{Name}},\n\nMeet *{{Student_Name}}*, one of our successful graduates from Course Name! After completing the program, {{Student_Name}} went on to Achievement/Job Title.\n\nHere’s what they had to say about their experience with us:\n"Student Testimonial Quote"\n\nJoin {{Student_Name}} and many others who have transformed their careers through our programs. Find out more: {{url}}\n\nBest regards,\n{{Institution_name}}`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [{"type": "url", "parameter": {"text": "Learn more", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: null,
  },

  {
    id: '6709442f7b7f3f2e57cd38eb',
    name: 'diwali_new_general',
    tags: ["Festival"],
    content: `*🌟✨ Happy Diwali! ✨🌟*\n\nDear {Name},\n\nWishing you and your loved ones a Diwali filled with joy, prosperity, and peace. May the festival of lights illuminate your life with endless happiness, success, and good health.\n\nLet’s celebrate this Diwali by spreading love, kindness, and positivity! 🪔\n\nHave a sparkling and safe Diwali! 🧡🎇\n\nWarm regards,\n\n{Your Name}`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://www.google.com/imgres?q=diwali%20pictures%20freepik&imgurl=https%3A%2F%2Fimg.freepik.com%2Ffree-vector%2Findian-style-happy-diwali-red-shiny-background_1017-28593.jpg&imgrefurl=https%3A%2F%2Fwww.freepik.com%2Ffree-photos-vectors%2Fdiwali&docid=LF4drP_Ipw9oNM&tbnid=kHrv9r_TmddYiM&vet=12ahUKEwjKqZ750YaJAxUQUkEAHR9mFNgQM3oECG4QAA..i&w=626&h=626&hcb=2&ved=2ahUKEwjKqZ750YaJAxUQUkEAHR9mFNgQM3oECG4QAA", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '6709444463411b9ebd62c361',
    name: 'diwali_new_general',
    tags: ["Festival"],
    content: `*🌟✨ Happy Diwali! ✨🌟*\n\nDear {Name},\n\nWishing you and your loved ones a Diwali filled with joy, prosperity, and peace. May the festival of lights illuminate your life with endless happiness, success, and good health.\n\nLet’s celebrate this Diwali by spreading love, kindness, and positivity! 🪔\n\nHave a sparkling and safe Diwali! 🧡🎇\n\nWarm regards,\n\n{Your Name}`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://www.google.com/imgres?q=diwali%20pictures%20freepik&imgurl=https%3A%2F%2Fimg.freepik.com%2Ffree-vector%2Findian-style-happy-diwali-red-shiny-background_1017-28593.jpg&imgrefurl=https%3A%2F%2Fwww.freepik.com%2Ffree-photos-vectors%2Fdiwali&docid=LF4drP_Ipw9oNM&tbnid=kHrv9r_TmddYiM&vet=12ahUKEwjKqZ750YaJAxUQUkEAHR9mFNgQM3oECG4QAA..i&w=626&h=626&hcb=2&ved=2ahUKEwjKqZ750YaJAxUQUkEAHR9mFNgQM3oECG4QAA", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '6709451f30ccbff06b837147',
    name: 'diwali_deals',
    tags: ["Festival"],
    content: `*🪔✨ Diwali Deals are Here! ✨🪔*\n\nHello {Name},\n\nCelebrate Diwali with *up to 50% OFF* on the latest (Product Category)! 🎉 Shop our *Buy 1 Get 1 FREE*, *Flat 30% OFF* festive collections, and more!\n\n✨ *New Arrivals*: Grab the hottest (Product Category) now!\n\n🎁 *Free Gifts* on purchases above (Amount)!\n\nHurry, offers end soon! Shop now: {Link} 🛍️\n\nWishing you a bright and prosperous Diwali! 🎇\n\n{Your Store Name}`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [{"type": "url", "parameter": {"text": "I want these deals", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://www.google.com/imgres?q=diwali%20pictures%20freepik&imgurl=https%3A%2F%2Fimg.freepik.com%2Ffree-vector%2Findian-style-happy-diwali-red-shiny-background_1017-28593.jpg&imgrefurl=https%3A%2F%2Fwww.freepik.com%2Ffree-photos-vectors%2Fdiwali&docid=LF4drP_Ipw9oNM&tbnid=kHrv9r_TmddYiM&vet=12ahUKEwjKqZ750YaJAxUQUkEAHR9mFNgQM3oECG4QAA..i&w=626&h=626&hcb=2&ved=2ahUKEwjKqZ750YaJAxUQUkEAHR9mFNgQM3oECG4QAA", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '6709452f6344ee9bb8c4a297',
    name: 'diwali_deals',
    tags: ["Festival"],
    content: `*🪔✨ Diwali Deals are Here! ✨🪔*\n\nHello {Name},\n\nCelebrate Diwali with *up to 50% OFF* on the latest (Product Category)! 🎉 Shop our *Buy 1 Get 1 FREE*, *Flat 30% OFF* festive collections, and more!\n\n✨ *New Arrivals*: Grab the hottest (Product Category) now!\n\n🎁 *Free Gifts* on purchases above (Amount)!\n\nHurry, offers end soon! Shop now: {Link} 🛍️\n\nWishing you a bright and prosperous Diwali! 🎇\n\n{Your Store Name}`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [{"type": "url", "parameter": {"text": "I want these deals", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://www.google.com/imgres?q=diwali%20pictures%20freepik&imgurl=https%3A%2F%2Fimg.freepik.com%2Ffree-vector%2Findian-style-happy-diwali-red-shiny-background_1017-28593.jpg&imgrefurl=https%3A%2F%2Fwww.freepik.com%2Ffree-photos-vectors%2Fdiwali&docid=LF4drP_Ipw9oNM&tbnid=kHrv9r_TmddYiM&vet=12ahUKEwjKqZ750YaJAxUQUkEAHR9mFNgQM3oECG4QAA..i&w=626&h=626&hcb=2&ved=2ahUKEwjKqZ750YaJAxUQUkEAHR9mFNgQM3oECG4QAA", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '6709470ebc3f5db5dea4deab',
    name: 'diwali_deals_edu',
    tags: ["Festival", "Education"],
    content: `*🪔📚 Brighten Your Future This Diwali! 📚🪔*\n\nHello {Name},\n\nThis Diwali, unlock your potential with our *special education deals*! 🎉✨\n\n🎇 *Flat 30% OFF* on all online courses!\n\n🎆 *Buy 1 Course, Get 1 FREE* on select programs.\n\n🪔 *Free E-books* on every enrollment!\n\nUpgrade your skills with the latest (Subject/Skill) courses and kickstart your journey to success.\n\n📅 *Offer valid till (End Date)*. Don’t miss out!\n\n👉 Enroll Now: {link}\n\nWishing you a prosperous and enlightened Diwali! 🌟\n\n{Your Company Name}`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [{"type": "url", "parameter": {"text": "I want these deals", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://www.google.com/imgres?q=diwali%20pictures%20freepik&imgurl=https%3A%2F%2Fimg.freepik.com%2Ffree-vector%2Findian-style-happy-diwali-red-shiny-background_1017-28593.jpg&imgrefurl=https%3A%2F%2Fwww.freepik.com%2Ffree-photos-vectors%2Fdiwali&docid=LF4drP_Ipw9oNM&tbnid=kHrv9r_TmddYiM&vet=12ahUKEwjKqZ750YaJAxUQUkEAHR9mFNgQM3oECG4QAA..i&w=626&h=626&hcb=2&ved=2ahUKEwjKqZ750YaJAxUQUkEAHR9mFNgQM3oECG4QAA", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '6709471a6344ee9bb8c4a298',
    name: 'diwali_deals_edu',
    tags: ["Festival", "Education"],
    content: `*🪔📚 Brighten Your Future This Diwali! 📚🪔*\n\nHello {Name},\n\nThis Diwali, unlock your potential with our *special education deals*! 🎉✨\n\n🎇 *Flat 30% OFF* on all online courses!\n\n🎆 *Buy 1 Course, Get 1 FREE* on select programs.\n\n🪔 *Free E-books* on every enrollment!\n\nUpgrade your skills with the latest (Subject/Skill) courses and kickstart your journey to success.\n\n📅 *Offer valid till (End Date)*. Don’t miss out!\n\n👉 Enroll Now: {link}\n\nWishing you a prosperous and enlightened Diwali! 🌟\n\n{Your Company Name}`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [{"type": "url", "parameter": {"text": "I want these deals", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://www.google.com/imgres?q=diwali%20pictures%20freepik&imgurl=https%3A%2F%2Fimg.freepik.com%2Ffree-vector%2Findian-style-happy-diwali-red-shiny-background_1017-28593.jpg&imgrefurl=https%3A%2F%2Fwww.freepik.com%2Ffree-photos-vectors%2Fdiwali&docid=LF4drP_Ipw9oNM&tbnid=kHrv9r_TmddYiM&vet=12ahUKEwjKqZ750YaJAxUQUkEAHR9mFNgQM3oECG4QAA..i&w=626&h=626&hcb=2&ved=2ahUKEwjKqZ750YaJAxUQUkEAHR9mFNgQM3oECG4QAA", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '67094861923349ed905dad2f',
    name: 'diwali_deals_healthcare',
    tags: ["Festival", "Healthcare"],
    content: `*🪔🌟 Stay Healthy This Diwali with Special Offers! 🌟🪔*\n\nHello {Customer Name},\n\nThis Diwali, gift yourself and your loved ones the best of health! 🎉\n\n🎇 *Flat 25% OFF* on health checkups.\n\n🎆 *Buy 1 Get 1 FREE* on wellness consultations.\n\n🪔 *Special Discounts* on (Healthcare Products/Services)!\n\nYour health is the greatest wealth—let's make it a priority this festive season.\n\n📅 *Offer valid till (End Date)*. Book now: {url}\n\n📞 For appointments, call (Phone Number).\n\nWishing you a healthy and joyous Diwali! 🎇✨\n\n(Your Clinic/Brand Name)`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [{"type": "url", "parameter": {"text": "I want these deals", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://www.google.com/imgres?q=diwali%20pictures%20freepik&imgurl=https%3A%2F%2Fimg.freepik.com%2Ffree-vector%2Findian-style-happy-diwali-red-shiny-background_1017-28593.jpg&imgrefurl=https%3A%2F%2Fwww.freepik.com%2Ffree-photos-vectors%2Fdiwali&docid=LF4drP_Ipw9oNM&tbnid=kHrv9r_TmddYiM&vet=12ahUKEwjKqZ750YaJAxUQUkEAHR9mFNgQM3oECG4QAA..i&w=626&h=626&hcb=2&ved=2ahUKEwjKqZ750YaJAxUQUkEAHR9mFNgQM3oECG4QAA", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '6709486bd88159cd5ac0b3cb',
    name: 'diwali_deals_healthcare',
    tags: ["Festival", "Healthcare"],
    content: `*🪔🌟 Stay Healthy This Diwali with Special Offers! 🌟🪔*\n\nHello {Customer Name},\n\nThis Diwali, gift yourself and your loved ones the best of health! 🎉\n\n🎇 *Flat 25% OFF* on health checkups.\n\n🎆 *Buy 1 Get 1 FREE* on wellness consultations.\n\n🪔 *Special Discounts* on (Healthcare Products/Services)!\n\nYour health is the greatest wealth—let's make it a priority this festive season.\n\n📅 *Offer valid till (End Date)*. Book now: {url}\n\n📞 For appointments, call (Phone Number).\n\nWishing you a healthy and joyous Diwali! 🎇✨\n\n(Your Clinic/Brand Name)`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [{"type": "url", "parameter": {"text": "I want these deals", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://www.google.com/imgres?q=diwali%20pictures%20freepik&imgurl=https%3A%2F%2Fimg.freepik.com%2Ffree-vector%2Findian-style-happy-diwali-red-shiny-background_1017-28593.jpg&imgrefurl=https%3A%2F%2Fwww.freepik.com%2Ffree-photos-vectors%2Fdiwali&docid=LF4drP_Ipw9oNM&tbnid=kHrv9r_TmddYiM&vet=12ahUKEwjKqZ750YaJAxUQUkEAHR9mFNgQM3oECG4QAA..i&w=626&h=626&hcb=2&ved=2ahUKEwjKqZ750YaJAxUQUkEAHR9mFNgQM3oECG4QAA", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '67094a2e44a1d4e98456065b',
    name: 'navratri_greetings',
    tags: ["Festival"],
    content: `*🌼✨ Happy Navratri & Dussehra! ✨🌼*\n\nDear {Name},\n\nWishing you a joyful Navratri filled with love and devotion! May Goddess Durga bless you with strength and happiness. 🪔🙏\n\nAs we celebrate Dussehra, may the victory of good over evil inspire you to overcome all challenges.\n\nHave a vibrant and blessed festive season! 🎉\n\nWarm wishes,\n\n(Company Name)`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://www.google.com/imgres?q=navratri%20freepik&imgurl=https%3A%2F%2Fimg.freepik.com%2Fpremium-photo%2Fthis-mythological-design-is-designed-happy-navratri-happy-durga-puja_1119325-136111.jpg&imgrefurl=https%3A%2F%2Fwww.freepik.com%2Ffree-photos-vectors%2Fnavratri-festival&docid=m076u41RgSpsjM&tbnid=7YFlECtNnu48MM&vet=12ahUKEwju04rO14aJAxXEXEEAHcK8BWAQM3oECEgQAA..i&w=626&h=569&hcb=2&ved=2ahUKEwju04rO14aJAxXEXEEAHcK8BWAQM3oECEgQAA", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '67094a3544a1d4e98456065c',
    name: 'navratri_greetings',
    tags: ["Festival"],
    content: `*🌼✨ Happy Navratri & Dussehra! ✨🌼*\n\nDear {Name},\n\nWishing you a joyful Navratri filled with love and devotion! May Goddess Durga bless you with strength and happiness. 🪔🙏\n\nAs we celebrate Dussehra, may the victory of good over evil inspire you to overcome all challenges.\n\nHave a vibrant and blessed festive season! 🎉\n\nWarm wishes,\n\n(Company Name)`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://www.google.com/imgres?q=navratri%20freepik&imgurl=https%3A%2F%2Fimg.freepik.com%2Fpremium-photo%2Fthis-mythological-design-is-designed-happy-navratri-happy-durga-puja_1119325-136111.jpg&imgrefurl=https%3A%2F%2Fwww.freepik.com%2Ffree-photos-vectors%2Fnavratri-festival&docid=m076u41RgSpsjM&tbnid=7YFlECtNnu48MM&vet=12ahUKEwju04rO14aJAxXEXEEAHcK8BWAQM3oECEgQAA..i&w=626&h=569&hcb=2&ved=2ahUKEwju04rO14aJAxXEXEEAHcK8BWAQM3oECEgQAA", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '67094b8744a1d4e984560664',
    name: 'navratri_deals',
    tags: ["Festival"],
    content: `*🌼✨ Celebrate Navratri & Dussehra with Special Offers! ✨🌼*\n\nDear {Name},\n\nThis festive season, enjoy *up to 40% OFF* on our exclusive collection of [products] as we celebrate Navratri and Dussehra! 🎉🛍️\n\n🪔 *Special Deals:*\n\n- *Buy 1, Get 1 FREE* on selected items!\n- *Flat 30% OFF* on all (product category)!\n- *Free gifts* with every purchase above (amount)!\n\nHurry, offers valid until (end date)! Shop now: {url}\n\nWishing you a joyful and prosperous festive season! 🎇\n\nWarm regards,\n\n(Company Name)`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [{"type": "url", "parameter": {"text": "I want these deals", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://www.google.com/imgres?q=navratri%20freepik&imgurl=https%3A%2F%2Fimg.freepik.com%2Fpremium-photo%2Fthis-mythological-design-is-designed-happy-navratri-happy-durga-puja_1119325-136111.jpg&imgrefurl=https%3A%2F%2Fwww.freepik.com%2Ffree-photos-vectors%2Fnavratri-festival&docid=m076u41RgSpsjM&tbnid=7YFlECtNnu48MM&vet=12ahUKEwju04rO14aJAxXEXEEAHcK8BWAQM3oECEgQAA..i&w=626&h=569&hcb=2&ved=2ahUKEwju04rO14aJAxXEXEEAHcK8BWAQM3oECEgQAA", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '67094b9044a1d4e984560665',
    name: 'navratri_deals',
    tags: ["Festival"],
    content: `*🌼✨ Celebrate Navratri & Dussehra with Special Offers! ✨🌼*\n\nDear {Name},\n\nThis festive season, enjoy *up to 40% OFF* on our exclusive collection of [products] as we celebrate Navratri and Dussehra! 🎉🛍️\n\n🪔 *Special Deals:*\n\n- *Buy 1, Get 1 FREE* on selected items!\n- *Flat 30% OFF* on all (product category)!\n- *Free gifts* with every purchase above (amount)!\n\nHurry, offers valid until (end date)! Shop now: {url}\n\nWishing you a joyful and prosperous festive season! 🎇\n\nWarm regards,\n\n(Company Name)`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [{"type": "url", "parameter": {"text": "I want these deals", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://www.google.com/imgres?q=navratri%20freepik&imgurl=https%3A%2F%2Fimg.freepik.com%2Fpremium-photo%2Fthis-mythological-design-is-designed-happy-navratri-happy-durga-puja_1119325-136111.jpg&imgrefurl=https%3A%2F%2Fwww.freepik.com%2Ffree-photos-vectors%2Fnavratri-festival&docid=m076u41RgSpsjM&tbnid=7YFlECtNnu48MM&vet=12ahUKEwju04rO14aJAxXEXEEAHcK8BWAQM3oECEgQAA..i&w=626&h=569&hcb=2&ved=2ahUKEwju04rO14aJAxXEXEEAHcK8BWAQM3oECEgQAA", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '66bc82a3618bbcec2cf3c190',
    name: 'independence_day24',
    tags: ["Festival"],
    content: `🇮🇳 *Happy Independence Day!* 🇮🇳\n\nCelebrate with us and enjoy *FREE SHIPPING* on all orders today! Use code: *INDEPENDENCE2024* at checkout.\n\nJai Hind! 🎉`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [{"type": 6, "parameter": {"text": "Copy offer code", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "none", "buttonParamMapping": null}}],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://img.freepik.com/free-vector/india-independence-day-illustration_23-2148997919.jpg?t=st=1723628004~exp=1723631604~hmac=e20ec9df9f7456032e220d2bb9bae8ae1a5a296da908d32ccadc5b0c2e818818&w=826", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '66bc83102beda19dc84ec19b',
    name: 'independence_20off',
    tags: ["Festival"],
    content: `🇮🇳 *Happy Independence Day* 🇮🇳\n\nCelebrate with us and get an *exclusive 20% discount* on all orders! Use code: *INDEPENDENCE20* at checkout.\n\nDon't miss out on this special offer. Jai Hind! 🎉`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [{"type": 6, "parameter": {"text": "Copy offer code", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "none", "buttonParamMapping": null}}],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://img.freepik.com/free-vector/india-independence-day-illustration_23-2148997919.jpg?t=st=1723628004~exp=1723631604~hmac=e20ec9df9f7456032e220d2bb9bae8ae1a5a296da908d32ccadc5b0c2e818818&w=826", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '66bc83953c0a64afd0c551b1',
    name: 'independence_general',
    tags: ["Festival"],
    content: `🇮🇳 *Happy Independence Day!* 🇮🇳\n\nCelebrate the spirit of freedom with our *Independence Day Sale*! Enjoy amazing discounts on a wide range of products.\n\nJoin us in honoring this special day. Jai Hind! 🎉`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [{"type": 6, "parameter": {"text": "Copy offer code", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "none", "buttonParamMapping": null}}],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://img.freepik.com/free-vector/india-independence-day-illustration_23-2148997919.jpg?t=st=1723628004~exp=1723631604~hmac=e20ec9df9f7456032e220d2bb9bae8ae1a5a296da908d32ccadc5b0c2e818818&w=826", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '66bc859daedd3104e9ac75f0',
    name: 'raksha_bandhan',
    tags: ["Festival"],
    content: `🎉 *Happy Raksha Bandhan!* 🎉\n\nCelebrate the bond of love with our special *Raksha Bandhan Sale*! Enjoy *15% off* on all gifts and rakhis. Use code: *RAKHI15* at checkout.\n\nDon't miss out on this festive offer! 🛍️✨`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [{"type": "url", "parameter": {"text": "Shop now", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}, {"type": 6, "parameter": {"text": "Copy offer code", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "none", "buttonParamMapping": null}}],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://img.freepik.com/free-vector/gradient-raksha-bandhan-illustration_23-2149001582.jpg?t=st=1723629077~exp=1723632677~hmac=fab45bf486a54ee9a51df02f5e3a08477e34b45226b0f45334946ec0bdd60217&w=826", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '66bc860f470a595f3187cbcf',
    name: 'raksha_bandhan_offer',
    tags: ["Festival"],
    content: `🎉 *Happy Raksha Bandhan!* 🎉\n\nCelebrate the festival with our *special Raksha Bandhan offer*! Enjoy *FREE SHIPPING* and an *extra 10% off* on all orders. Use code: *RAKHI10* at checkout.\n\nMake this Raksha Bandhan even more memorable! 🛍️✨`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [{"type": "url", "parameter": {"text": "Shop now", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}, {"type": 6, "parameter": {"text": "Copy offer code", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "none", "buttonParamMapping": null}}],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://img.freepik.com/free-vector/gradient-raksha-bandhan-illustration_23-2149001582.jpg?t=st=1723629077~exp=1723632677~hmac=fab45bf486a54ee9a51df02f5e3a08477e34b45226b0f45334946ec0bdd60217&w=826", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '66bc872c470a595f3187cbd0',
    name: 'raksha_bandhan_last_deals',
    tags: ["Festival"],
    content: `🎉 *Happy Raksha Bandhan!* 🎉\n\nStill need to get gifts? Take advantage of our *last-minute deals*! Enjoy great discounts and *FREE SHIPPING* on your purchases.\n\nDon't let time run out—shop now and make this Raksha Bandhan special! 🛍️✨`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [{"type": "url", "parameter": {"text": "Shop now", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://img.freepik.com/free-vector/gradient-raksha-bandhan-illustration_23-2149001582.jpg?t=st=1723629077~exp=1723632677~hmac=fab45bf486a54ee9a51df02f5e3a08477e34b45226b0f45334946ec0bdd60217&w=826", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '66bc87f83c0a64afd0c551b3',
    name: 'Janmashtami_greetings',
    tags: ["Festival"],
    content: `🌟 *Happy Janmashtami!* 🌟\n\nWishing you joy and blessings on this auspicious occasion of Lord Krishna's birth. May your life be filled with love, peace, and happiness.\n\nCelebrate with devotion and joy! 🕉️✨`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://img.freepik.com/free-vector/yellow-color-happy-janmashtami-festival-frame-background-design-vector_1055-10954.jpg?t=st=1723631554~exp=1723635154~hmac=4be4adf31329c49b26e76773ded937810767dd958d3f761833e158928d63929c&w=826", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '66bc88ef4de7b71cdf28692b',
    name: 'Janmashtami_deals',
    tags: ["Festival"],
    content: `🌟 *Happy Janmashtami!* 🌟\n\nCelebrate the joy of Lord Krishna’s birth with our amazing *Janmashtami Deals*! Enjoy up to *30% off* on selected items and *FREE SHIPPING* on all orders.\n\nShop now and bring home the festive spirit! 🛍️✨`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [{"type": "url", "parameter": {"text": "Shop now", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://img.freepik.com/free-vector/yellow-color-happy-janmashtami-festival-frame-background-design-vector_1055-10954.jpg?t=st=1723631554~exp=1723635154~hmac=4be4adf31329c49b26e76773ded937810767dd958d3f761833e158928d63929c&w=826", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '66b9ed0dd0bbdf23efedf2dc',
    name: 'utility_followup',
    tags: ["Others"],
    content: `Dear {{name}},\n\nThis is a follow up message as we haven't heard back from you yet! \n\nPlease respond to this message or click on the link below to confirm`,
    category: 'UTILITY',
    language: 'English',
    footer: null,
    buttons: [{"type": "url", "parameter": {"text": "Keep me updated", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: null,
  },

  {
    id: '66b9ed491b24e075d2ed3aac',
    name: 'utility_eventreminder',
    tags: ["Others"],
    content: `Dear {{name}}, \n\nThis is an event reminder! Your event will start soon, click the link below to access it! 👇`,
    category: 'UTILITY',
    language: 'English',
    footer: null,
    buttons: [{"type": "url", "parameter": {"text": "Joining now", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: null,
  },

  {
    id: '66b9efd9d0bbdf23efedf2dd',
    name: 'utility_feedback',
    tags: ["Others"],
    content: `*How did we do?*\n\nDear {{name}}, \n\nWe want to hear from you! Your feedback matters to us. \n\nPlease help take a quick survey to let us know how we can do better`,
    category: 'UTILITY',
    language: 'English',
    footer: null,
    buttons: [{"type": "url", "parameter": {"text": "Leave feedback", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: null,
  },

  {
    id: '66b9f11cd0bbdf23efedf2de',
    name: 'utility_optin',
    tags: ["Others"],
    content: `*Confirmation required*\n\nDear {{name}}, \n\nPlease click on the link below to confirm that you'd like to hear from us!`,
    category: 'UTILITY',
    language: 'English',
    footer: null,
    buttons: [{"type": "url", "parameter": {"text": "Keep me informed", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: null,
  },

  {
    id: '66b9f1fdc854f055dd7393f4',
    name: 'utility_order',
    tags: ["Others", "E-Commerce"],
    content: `*Order success*\n\nDear {{name}}, \n\nThanks for ordering from us! We've got your order {{order_number}}, you'll be informed when the order has been shipped out!`,
    category: 'UTILITY',
    language: 'English',
    footer: null,
    buttons: [{"type": "url", "parameter": {"text": "Track order", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}, {"type": "call", "parameter": {"text": "I need help", "phoneNumber": "19518214969", "url": null, "urlOriginal": null, "urlType": "none", "buttonParamMapping": null}}],
    header: null,
  },

  {
    id: '66683a6db1162bae32e7b3e3',
    name: 'eid al adha overall discount',
    tags: ["Festival"],
    content: `Dear {{name}},\n\n🌙✨ Gear up for Eid al-Adha with exclusive discounts across all products! From traditional attire to festive decor, we've got everything you need to make this Eid memorable. \n\nUse code *EIDSALE15* for 15% off your entire purchase. \n\nLet's prepare for a joyous celebration filled with blessings and togetherness.  \nShop now and spread the Eid spirit! \n[Your company name]`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [{"type": 6, "parameter": {"text": "Copy offer code", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "none", "buttonParamMapping": null}}],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://img.freepik.com/free-vector/beautiful-islamic-eid-al-adha-mubarak-greeting-card_1055-10459.jpg?size=338&ext=jpg&ga=GA1.1.553209589.1715040000&semt=ais", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '66683e0a5f0e5518d9fd4ffa',
    name: 'eid al adha vip',
    tags: ["Festival"],
    content: `*VIP Early Access Sale Alert!* 🛍️ \n\n{{name}} Get ahead of the Eid al-Adha rush with exclusive VIP access to our special sale event. Treat yourself and your loved ones to exquisite gifts, elegant attire, and festive decor before anyone else. Limited-time offers await you! \n\nDon't miss out on this opportunity to shop ahead and make this Eid unforgettable. \n\nSign up now for VIP access.`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [{"type": "url", "parameter": {"text": "Shop now", "phoneNumber": "", "url": "https://www.wati.io", "urlOriginal": null, "urlType": "static", "buttonParamMapping": null}}],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://img.freepik.com/free-vector/beautiful-islamic-eid-al-adha-mubarak-greeting-card_1055-10459.jpg?size=338&ext=jpg&ga=GA1.1.553209589.1715040000&semt=ais", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '663cece681004820f096509f',
    name: 'enrollment_confirmation',
    tags: ["Education"],
    content: `Hi {{name}},\n\nYou’re officially enrolled on our course - {{course name}} 🎉 📖\n\nPerfect time for some learning and to get you ready - attached are the essential details for your reference.\n\nFor any questions, contact us at (contact information).`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://img.freepik.com/free-vector/online-school-platform-abstract-concept-vector-illustration-homeschooling-covid2019-qarantine-online-education-platform-digital-classes-virtual-courses-lms-school-abstract-metaphor_335657-5850.jpg?size=338&ext=jpg&ga=GA1.1.1687694167.1711670400&semt=sph", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '663cf0d79c9b30f226ebc92e',
    name: 'enrollment_payment',
    tags: ["Education"],
    content: `🎓 Hey there, {{student_name}}!\n\nExciting news! You're all set to join our {{course_name}} course.\n\n🚀 To finalize your enrolment and to secure your spot, just click the link below to head to the payment page:\n\n{{payment_link}}\n\nWe're thrilled to have you on board!\n\nWarm regards,\n(Your Name)`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://img.freepik.com/free-vector/online-school-platform-abstract-concept-vector-illustration-homeschooling-covid2019-qarantine-online-education-platform-digital-classes-virtual-courses-lms-school-abstract-metaphor_335657-5850.jpg?size=338&ext=jpg&ga=GA1.1.1687694167.1711670400&semt=sph", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '663cf136954e7de120a634d5',
    name: 'enrollment_payment',
    tags: ["Education"],
    content: `Hi {{name}}!\n\nReady to explore new interests or advance your career?  📖 We offer a range of courses at [Institute/Organization Name]!\n\nDiscover:\n\n- Course 1: (Brief description)\n- Course 2: [Brief description)\n- Course 3: [Brief description)\n- And more!\n\nFind your next adventure at {{website link}}.\n\nBest,\n(Your Name)`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://img.freepik.com/free-vector/online-certification-illustration_23-2148575636.jpg?size=338&ext=jpg&ga=GA1.1.1224184972.1714694400&semt=sph", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '660c33dddadcd7c8130f8974',
    name: 'songkran offer',
    tags: ["Festival"],
    content: `🎉🌺 Songkran Special Offers! 🌺🎉\n\nCelebrate Songkran with us and enjoy fantastic deals! Get FREE delivery on all orders and an exclusive discount below (*SONGKRAN20*) to make your celebrations even sweeter!\n\n🛍️🎁 Don't miss out! Shop now and save big this Songkran! 🎉💰\n\n(Shop Now)\n\nHappy Songkran!`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [{"type": 6, "parameter": {"text": "Copy offer code", "phoneNumber": "", "url": null, "urlOriginal": null, "urlType": "none", "buttonParamMapping": null}}],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://img.freepik.com/free-vector/hand-drawn-style-songkran-event_23-2148473122.jpg?size=626&ext=jpg&ga=GA1.1.1395880969.1709683200&semt=ais", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '660c34548ae729493f2bc463',
    name: 'songkran general',
    tags: ["Festival"],
    content: `🌺 Happy Songkran {{name}}! 🌺\n\nWishing you a joyous Thai New Year filled with happiness and prosperity! May this Songkran bring you closer to loved ones and shower you with blessings.\n\nLet's celebrate with joy and water splashes! Have a fantastic Songkran!`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://img.freepik.com/free-vector/hand-drawn-style-songkran-event_23-2148473122.jpg?size=626&ext=jpg&ga=GA1.1.1395880969.1709683200&semt=ais", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '660197a9636eaa8ed506b5bd',
    name: 'Laylat al qadr greetings',
    tags: ["Festival"],
    content: `🌙🕌 Laylat al-Qadr Greetings! 🌙🕌\n\nDear {{name}},\n\nAs the blessed night descends upon us, may Allah's mercy and blessings illuminate your life with peace, happiness, and prosperity. 🌟 Let us immerse ourselves in prayer, reflection, and gratitude, seeking the divine blessings of this sacred night. 🙏✨\n\nWishing you and your family a blessed Laylat al-Qadr! 🌙🤲`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://img.freepik.com/free-vector/gradient-laylat-al-qadr-illustration_23-2148901272.jpg", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '66019922c654e7a5ff473110',
    name: 'Laylat al qadr sale',
    tags: ["Festival"],
    content: `🌙✨ Laylat al-Qadr Sale! ✨🌙\n\nCelebrate this blessed night with exclusive deals!\n🎉 Up to 50% OFF selected items!\n🛍️ Limited-time offers!\n\nShop now & embrace the blessings of Laylat al-Qadr!`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://img.freepik.com/free-vector/gradient-laylat-al-qadr-illustration_23-2148912132.jpg", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '6601a0b4636eaa8ed506b5bf',
    name: 'Laylat al qadr sale',
    tags: ["Festival"],
    content: `🌙✨ Laylat al-Qadr Sale! ✨🌙\n\nCelebrate this blessed night with exclusive deals!\n🎉 Up to 50% OFF selected items!\n🛍️ Limited-time offers!\n\nShop now & embrace the blessings of Laylat al-Qadr!`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://img.freepik.com/free-vector/gradient-laylat-al-qadr-illustration_23-2148912132.jpg", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '65f1a2f71bd60c623488563a',
    name: 'holi greetings us',
    tags: ["Festival"],
    content: `🎨 *Happy Holi!*\n\n 🌈 Let's splash the colors of joy and happiness this Holi! 🎉 May your life be as vibrant as the colors of this festival. \n\n🌟 Wishing you and your loved ones a day filled with laughter, love, and endless memories! 💖 \n\nHappy Holi! 🎨🌈`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://img.freepik.com/free-vector/splashes-colors-happy-holi-festival-background_1017-23705.jpg", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '65f1a38774cb11ee0e42a6ca',
    name: 'holi sale us',
    tags: ["Festival"],
    content: `🎨 *Celebrate Holi with Colorful Savings! 🌈*\n\nHappy Holi! To add more color to your celebrations, we're offering an exclusive discount code: *HOLI20* 🎉\n\nEnjoy a *20% discount* on all purchases during this festive season! 🛍️\n\nHurry, this offer is valid for a limited time only! Don't miss out on these colorful savings! 🎨✨\n\nHappy Holi from (Your Company Name)! 🌈🎉`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://img.freepik.com/premium-vector/vector-illustration-happy-holi-sale-banner-template-app-website_181203-12811.jpg", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '65de673ac3c47525dd969be5',
    name: 'ramadan greetings',
    tags: ["Festival"],
    content: `🌙 *Ramadan Kareem!* 🌟\n\nMay the holy month of Ramadan bring you peace, prosperity, and blessings. 🕌✨\n\nWishing you and your family a joyful Ramadan filled with love, forgiveness, and spiritual growth. 🌟🌙\n\nRamadan Mubarak! 🌙✨`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://www.destinations.com.tr/wp-content/uploads/2023/06/ramadan.webp", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '65de68a64ea2f773b578b68a',
    name: 'ramadan discounts',
    tags: ["Festival"],
    content: `🌙 *Ramadan Sale Alert!* 🛍️\n\nCelebrate the spirit of Ramadan with our exclusive deals and discounts! ✨\n\n🎁 Enjoy special offers on a wide range of products throughout the holy month; use the code: *ESSENTIALS10* for 10% off\n\n🛒 Don't miss out on this opportunity to shop for Ramadan essentials and more at unbeatable prices!\n\n🌟 Hurry, limited time only! Make your Ramadan even more delightful with our fantastic deals.\n\n🕌 Wishing you a blessed Ramadan filled with joy, prosperity, and savings! 🌙`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://img.freepik.com/premium-vector/ramadan-sale_15624-11.jpg", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '65de69379f0e337408fbc7bd',
    name: 'ramadan free delivery',
    tags: ["Festival"],
    content: `🌙 *Ramadan free delivery!* 🛻\n\n🛒 Don't miss out on this opportunity to shop for Ramadan essentials and more at unbeatable prices! \n\n🌟 We’re offering free delivery on all orders with the code: *SHIPIT*\n\n🕌 Wishing you a blessed Ramadan filled with joy, prosperity, and savings! 🌙`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://img.freepik.com/premium-vector/free-delivery-banner-with-courier-scooter-delivers-package-free-shipping-order-fast-delivery-badge-advertisement-express-delivery-with-man-scooter-vector-illustration_435184-1202.jpg", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '65de6999f23fd282a4b295ef',
    name: 'ramadan free delivery',
    tags: ["Festival"],
    content: `🌙✨ *Ramadan Flash Offer!* ✨🌙\n\nHey {{Name}}! 🌟\n\nExclusive Ramadan deal available now! 🎉\n\n📅 *Offer*: (Duration) | 🕒 *Time*: (Start Time)\n\nLimited time only! Don't miss out! 🌙💫\n\nShare with friends & family! 🕌🌟`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://img.freepik.com/free-vector/flash-sale-discount-banner-design-vector-illustration_1017-38420.jpg", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '65de6aed1c9f8f5ddbd62e9d',
    name: 'holi greetings',
    tags: ["Festival"],
    content: `🎨 *Happy Holi!* 🌈\n\nLet's splash the colors of joy and happiness this Holi! 🎉\n\nMay your life be as vibrant as the colors of this festival. 🌟\n\nWishing you and your loved ones a day filled with laughter, love, and endless memories! 💖\n\nHappy Holi! 🎨🌈`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://img.freepik.com/free-vector/splashes-colors-happy-holi-festival-background_1017-23705.jpg", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '65de6bc422071da6af2f65f3',
    name: 'holi sale',
    tags: ["Festival"],
    content: `🎨 *Celebrate Holi with Colorful Savings!* 🌈\n\nHappy Holi! To add more color to your celebrations, we're offering an exclusive discount code: *HOLISALE* 🎉\n\nEnjoy a *X% discount* on all purchases during this festive season! 🛍️\n\nHurry, this offer is valid for a limited time only! Don't miss out on these colorful savings! 🎨✨\n\nHappy Holi from (Your Company Name)! 🌈🎉`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://img.freepik.com/premium-vector/vector-illustration-happy-holi-sale-banner-template-app-website_181203-12811.jpg", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '65de6da81c9f8f5ddbd62e9e',
    name: 'easter sale',
    tags: ["Festival"],
    content: `🌷🐰🥚 *Happy Easter Savings!* 🥚🐰🌷\n\nCelebrate this Easter season with joy and savings! As a token of our appreciation, we're delighted to offer you an exclusive Easter discount on all our products.\n\n🎉 Enjoy a *20% discount* on your next purchase! 🎉\n\nUse code: *EASTER20* at checkout to redeem your discount.\n\n(Your company name)`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://img.freepik.com/free-vector/easter-holiday-watercolor-big-egg_52683-34160.jpg", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '65de6e0f22071da6af2f65f5',
    name: 'iwd',
    tags: ["Festival"],
    content: `Hi {{name}},\n\nHappy International Women's Day!\n\nTo all the amazing women out there: keep rocking your awesomeness, breaking barriers, and shining bright! Here's to you! ✨💪🎉`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [],
    header: {"type": 2, "typeString": "image", "text": null, "link": "https://img.freepik.com/free-vector/flat-international-women-s-day-illustration_23-2148863941.jpg?size=338&ext=jpg&ga=GA1.1.98259409.1708992000&semt=ais", "mediaHeaderId": "", "mediaFromPC": "", "headerOriginal": null, "headerParamMapping": null},
  },

  {
    id: '65d874d04126d40df074968c',
    name: 'Brazil carnival',
    tags: ["Festival"],
    content: `🎉🥳 Feliz Carnaval do Rio! 🎊🎶\n\nOi tudo bem! 🌟\n\nDesejando a você um Carnaval do Rio fantástico, cheio de alegria, risos e momentos inesquecíveis! 🥳💃🕺\n\nVamos celebrar o espírito do Carnaval juntos, não importa onde estejamos! 🎉🌍\n\n[Seu Nome/Organização]`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [],
    header: null,
  },

  {
    id: '65d875a0a7e203fe590447db',
    name: 'taj mahotsav',
    tags: ["Festival"],
    content: `🎉🕌 *Warm Greetings for Taj Mahotsav!* 🎶🌟\n\nHey {{Name}}! 🎉\n\nAs Taj Mahotsav unfolds its vibrant tapestry of culture and heritage, I extend my heartfelt greetings to you!\n\nMay this celebration be a joyous reflection of India's rich traditions, artistry, and diversity. Let's revel in the colors, rhythms, and flavors that unite us in this cultural extravaganza! 💃🎨\n\nWishing you moments filled with laughter, camaraderie, and discovery as you immerse yourself in the magic of Taj Mahotsav! 🥳✨\n\n[Your Name/Organization]`,
    category: 'MARKETING',
    language: 'English',
    footer: null,
    buttons: [],
    header: null,
  }

];

// Get templates by tag
export const getTemplatesByTag = (tag) => {
  if (tag === 'All') {
    return broadcastTemplates;
  }
  return broadcastTemplates.filter(template => 
    template.tags && template.tags.some(t => t.toLowerCase() === tag.toLowerCase())
  );
};

// Get all unique tags
export const getAllTags = () => {
  const allTags = broadcastTemplates.flatMap(template => template.tags || []);
  const uniqueTags = [...new Set(allTags)];
  return ['All', ...uniqueTags.sort()];
};

// Get template by ID
export const getTemplateById = (id) => {
  return broadcastTemplates.find(template => template.id === id);
};